import script from "./Catalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Catalog.vue?vue&type=script&lang=ts&setup=true"

import "./Catalog.vue?vue&type=style&index=0&id=38d0c09c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d0c09c"]])

export default __exports__